
/**
 * jQuery Cookie plugin
 *
 * Copyright (c) 2010 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
jQuery.cookie = function (key, value, options) {

    // key and at least value given, set cookie...
    if (arguments.length > 1 && String(value) !== "[object Object]") {
        options = jQuery.extend({}, options);

        if (value === null || value === undefined) {
            options.expires = -1;
        }

        if (typeof options.expires === 'number') {
            var days = options.expires, t = options.expires = new Date();
            t.setDate(t.getDate() + days);
        }

        value = String(value);

        return (document.cookie = [
            encodeURIComponent(key), '=',
            options.raw ? value : encodeURIComponent(value),
            options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
            options.path ? '; path=' + options.path : '',
            options.domain ? '; domain=' + options.domain : '',
            options.secure ? '; secure' : ''
        ].join(''));
    }

    // key and possibly options given, get cookie...
    options = value || {};
    var result, decode = options.raw ? function (s) { return s; } : decodeURIComponent;
    return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie)) ? decode(result[1]) : null;
};

// JQuery Plugin for parsing the query string
(function($) {
    $.QueryString = (function(a) {
        if (a == "") return {};
        var b = {};
        for (var i = 0; i < a.length; ++i)
        {
            var p=a[i].split('=');
            if (p.length != 2) continue;
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
        }
        return b;
    })(window.location.search.substr(1).split('&'))
})(jQuery);

var winWidth = $(window).width();

var current = window.location.href;
$('.child-navigation li a').each(function(){
    var $this = $(this);
    console.log(current)
    console.log($this.attr('href'))
    // if the current path is like this link, make it active
    if( $this.attr('href') === current ) {
      $this.parent('li').addClass('active');
    }
})

$('#posts--filter').on('change',function(e) {
  e.preventDefault();

  var $url = $(this).val() ? $(this).val() : '/news';
  document.location.href = $url;

});

if ( $('.people').length > 0 ) {

  $('.people--filter-link').on('click',function(e) {

    e.preventDefault();

    $('.people--filter-link').removeClass('active');
    $(this).addClass('active')

    var $cat = $(this).data('category');

    $('.person').filter(function( index ) {

      var $personCats = $(this).data('category');
      var $result = $personCats.indexOf($cat) < 0 ? true : false;

      if ( !$result && $(this).hasClass('is-hiding') ) {
        $(this).removeClass('is-hiding')
      }

      return $result;

    }).addClass('is-hiding');

  });

};

$(".brand--toggle").on("click", function(e) {

  e.preventDefault();
  $('body').toggleClass("menu-is-open");

});

$('.advance-arrow').on('click', function(e) {

  e.preventDefault();

  var nextSection  = $(this).closest('.kc-row-container').parent().next('.kc_row');
  var bannerHeight = $('.banner').data('scrolled-size') ? $('.banner').data('scrolled-size') : $('.banner').height();
  bannerHeight = winWidth < 768 ? $('.banner').height() : bannerHeight;
  var scrollHeight = nextSection.offset().top - bannerHeight;
  
  $('html,body').animate({
    scrollTop: scrollHeight
  }, 'slow');

});

var navScrolled = function() {

  var $window    = $(window);
  var docViewTop = 83;
  var nav        = $('.banner');
  var elemTop    = $window.scrollTop();

  if ( elemTop > docViewTop ) {
    nav.addClass('scrolled');
  } else {
    nav.removeClass('scrolled');
  }

};

navScrolled();

$( window ).scroll( function(e) {
  navScrolled();
});

if ( $('.fixed-row-element').length>0 ) {

  $('.fixed-row-element').each( function(index, value) {

    var $this = $(this);
    $(this).parent().css('position','relative');
    var elHeight     = $(this).innerHeight();
    var rowContainer = $(this).closest('.kc-row-container');
    var winScrollTop = $(window).scrollTop();
    var rowOffsetTop = rowContainer.offset().top;
    var rowHeight    = $(rowContainer).height();
    var elOffsetTop    = $(this).offset().top;

    // console.log(winScrollTop);
    // console.log(elHeight  );
    // console.log(elOffsetTop  );

    if ( elHeight >= rowHeight ) {
      rowContainer.css( 'height', elHeight + 'px' );
    }

    $(this).css({
      'top'      : elOffsetTop + 'px',
      'position' : 'fixed'
    });

    $( window ).scroll( function(e) {
      
      winScrollTop = $(window).scrollTop();

      // console.log(rowHeight-winScrollTop);
      // console.log(elOffsetTop + elHeight );

      //if ( ( rowHeight - rowOffsetTop - winScrollTop ) > ( rowHeight - elHeight ) ) {
      if ( (rowHeight-winScrollTop+60) <= (elOffsetTop + elHeight) ) {
        $this.css({
          'top'      : 'auto',
          'bottom' : '0',
          'position' : 'absolute'
        });
      } else {
        $this.css({
          'top'      : elOffsetTop + 'px',
          'position' : 'fixed'
        });
      }

      // console.log(winScrollTop);
      // console.log(elHeight  );
      // console.log(elOffsetTop  );
      // console.log('rowHeight => ' + rowHeight);

    });

  });

}

$('.cookies-notice--close').on( 'click', function (e) {

  e.preventDefault();

  var date = new Date();
  date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * 7));
  $.cookie("cookies-notice-dismissed", "1", { expires: date, path: '/' });
  $('body').addClass('cookies-notice-dismissed');

  if ( typeof __gaTracker !== "undefined" ) {

    __gaTracker('send', 'event', {
      eventCategory : 'Cookies Notice Dismissed',
      eventAction   : 'click',
      eventLabel    : label
    });

  }

});

if ( $('#disclaimer').length>0 ) {

  $('.disclaimer--banner-button').on( 'click', function (e) {

    e.preventDefault();

    if ( typeof __gaTracker !== "undefined" ) {

      __gaTracker('send', 'event', {
        eventCategory : 'Terms View Button',
        eventAction   : 'click',
        eventLabel    : label,
        transport     : 'beacon'
      });

    }

    window.location = '/disclaimer';

  });

  $('.disclaimer--terms-button').on( 'click', function (e) {

    e.preventDefault();

    var date = new Date();
    date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * 7));
    $.cookie("disclaimer-accepted", "1", { expires: date, path: '/' });

    if ( typeof __gaTracker !== "undefined" ) {

      __gaTracker('send', 'event', {
        eventCategory : 'Terms Accept Button',
        eventAction   : 'click',
        eventLabel    : label,
        transport     : 'beacon'
      });

    }

    if ( $('body').hasClass('disclaimer-interstitial') ) {
      var redirect = getUrlParameter('redirect');
      window.location = '/' + redirect;
    } else {
      $('#disclaimer').addClass( 'disclaimer-hide' );
      $('body').removeClass('disclaimer-popup-showing');
    }

  });

}

$('a[href$="pdf"]').on('click', function(e) {

  var label = $(this).attr('href');

  if ( typeof __gaTracker !== "undefined" ) {

    __gaTracker('send', 'event', {
      eventCategory : 'PDF Link',
      eventAction   : 'click',
      eventLabel    : label,
      transport     : 'beacon'
    });

  }

});

$('a:not([href$="pdf"]):not([href*="newarconic"]):not([href^="#"]):not([href^="/"])').on('click', function(e) {

  var label = $(this).attr('href');

  if ( typeof __gaTracker !== "undefined" ) {

    __gaTracker('send', 'event', {
      eventCategory : 'Outbound Link',
      eventAction   : 'click',
      eventLabel    : label,
      transport     : 'beacon'
    });

  }

});

var inView = function ( elements ) {

  var $window    = $(window);
  var docViewTop = $window.scrollTop() + $window.height() - ( $window.height() / 10 );

  elements.each( function( index ) {

    if ( !$(this).hasClass('over') ) {

      var elemTop = $(this).offset().top;

      if ( elemTop < docViewTop ) {
        $(this).addClass('over');
      }

    }

  });

};

inView( $('.inview') );

$( window ).scroll( function(e) {
  inView( $('.inview') );
});